export default __webpack_public_path__ + "static/media/wrapper-media3.75088019.jpg";